import { render, staticRenderFns } from "./ColleaguesFilterBar.vue?vue&type=template&id=4fb20160&scoped=true&"
import script from "./ColleaguesFilterBar.vue?vue&type=script&lang=js&"
export * from "./ColleaguesFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./ColleaguesFilterBar.vue?vue&type=style&index=0&id=4fb20160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb20160",
  null
  
)

export default component.exports